module.exports = __webpack_public_path__ + "static/media/five.5a2153a0.png";